module.exports = __webpack_public_path__ + "img/y20.6bacfe0f.jpg";